export default {
  state: {
    mgrData: {}
  },
  mutations: {
    setMgrData(state, data) {
      state.mgrData[data.codeId] = data.value;
    }
  }
}